import { createEntityAdapter } from "@reduxjs/toolkit";

import type { NetworkRequest } from "./types";

export const networkRequestEntityAdapter =
  createEntityAdapter<NetworkRequest>();
